<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box ">
      <Input v-model="searchName" style="width:140px;" placeholder="请输入渠道名称" :rows="4" />
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchCode" style="width:140px;" placeholder="请输入渠道Code" :rows="4" />
    </div>
    <div class="select-box " style="margin-left:360px;">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
      <!-- <Select style="width:200px" clearable @on-clear="clearAppId" @on-change="changeAppId">
        <Option v-for="item in appList" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select> -->
    <div class="option-wrap-channel">
      <Row>
        <Col >
          <Button type="primary" @click="addChannel">新增</Button>
        </Col>
      </Row>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal
      width="600"
      :mask-closable="false"
      :loading="loading"
      v-model="isShowEdit"
      :title="formType === 1?'修改渠道': '新增渠道'"
      @on-ok="editData('formEdit')">
      <Form ref="formEdit" :model="formEdit" :rules="ruleValidate"  :label-width="120">
        <FormItem label="渠道ID" v-show="false" prop="id">
          <Input v-model="formEdit.id" :rows="4" />
        </FormItem>
        <FormItem label="渠道code" prop="code">
          <Input v-model="formEdit.code" :disabled="formType === 1 ? true:false" placeholder="请输入渠道code" />
        </FormItem>
        <FormItem label="渠道名称" prop="name">
          <Input v-model="formEdit.name" :rows="4" placeholder="请输入渠道名称" />
        </FormItem>
        <FormItem label="CDN" prop="cdn_url">
          <Input v-model="formEdit.cdn_url" :rows="4" placeholder="请输入CDN" />
        </FormItem>
        <!-- <FormItem label="生成apk类型" prop="apk_type">
          <RadioGroup v-model="formEdit.apk_type">
              <Radio :label="1"><span>大apk</span></Radio>
              <Radio :label="2"><span>空apk</span></Radio>
          </RadioGroup>
        </FormItem> -->
        <FormItem label="备注" prop="remark">
          <Input v-model="formEdit.remark" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'channelManage',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      selectItems: [],
      sdkVersion: [],
      isShowEdit: false,
      formType: 0,
      searchName: '',
      searchCode: '',
      formEdit: {
        code: '',
        name: '',
        // apk_type: 1,
        remark: '',
        cdn_url: '',
        id: ''
      },
      role: [
        { name: '超级管理员', val: 1 },
        { name: '管理员', val: 2 },
        { name: '普通用户', val: 3 }
      ],
      ruleValidate: {
        code: [
          { required: true, message: '请输入渠道code' }
        ],
        cdn_url: [
          { required: false, message: '请输入CDN' }
        ],
        name: [
          { required: true, message: '请输入渠道名称' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '渠道名称',
          key: 'name',
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '渠道code',
          key: 'code',
          align: 'center',
          minWidth: 200
        },
        {
          title: 'CDN',
          key: 'cdn_url',
          align: 'center',
          minWidth: 200
        },
        // {
        //   title: '生成apk类型',
        //   key: 'apk_type',
        //   minWidth: 100,
        //   align: 'center',
        //   render: (h, params) => {
        //     if (params.row.apk_type === 1) {
        //       return h('span', {
        //         style: {
        //           width: '100px',
        //           height: '50px',
        //           textAlign: 'center',
        //           lineHeight: '50px'
        //         }
        //       }, '大apk')
        //     } else if (params.row.apk_type === 2) {
        //       return h('span', {
        //         style: {
        //           width: '100px',
        //           height: '50px',
        //           textAlign: 'center',
        //           lineHeight: '50px'
        //         }
        //       }, '空apk')
        //     }
        //   }
        // },
        {
          title: '备注',
          align: 'center',
          key: 'remark',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'created_at',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '更新时间',
          key: 'updated_at',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editAlert()
                    this.formEdit = {
                      code: params.row.code,
                      name: params.row.name,
                      cdn_url: params.row.cdn_url,
                      // apk_type: params.row.apk_type,
                      remark: params.row.remark,
                      id: params.row.id
                    }
                  }
                }
              }, '修改')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      // appList: [],
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
    // this.getAppList()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    loadData (name = '', code = '') {
      https.request({
        method: 'get',
        url: '/v2/es/channels',
        params: {
          name: name,
          code: code,
          page_size: 40
        }
      }).then(res => {
        this.tableLoading = false
        this.dataSource = res.data.items || []
        this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    addChannel () {
      this.$refs['formEdit'].resetFields()
      this.isShowEdit = true
      this.formType = 0
    },
    editAlert () {
      this.$refs['formEdit'].resetFields()
      this.isShowEdit = true
      this.formType = 1
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.changeLoading()
          if (this.formType === 1) {
            https.request({
              method: 'put',
              url: `/v2/es/channel`,
              data: {
                id: this.formEdit.id,
                name: this.formEdit.name,
                cdn_url: this.formEdit.cdn_url,
                // apk_type: this.formEdit.apk_type,
                remark: this.formEdit.remark
              }
            }).then(res => {
              if (res.data && res.data.code === 400) {
                this.$Message.error(res.data.message)
              } else {
                this.$Message.success('新增成功')
                this.loadData()
                this.isShowEdit = false
              }
            }).catch(error => {
              this.$Message.error(error)
            })
          } else if (this.formType === 0) {
            https.request({
              method: 'post',
              url: `/v2/es/channel`,
              data: {
                name: this.formEdit.name,
                code: this.formEdit.code,
                cdn_url: this.formEdit.cdn_url,
                // apk_type: this.formEdit.apk_type,
                remark: this.formEdit.remark
              }
            }).then(res => {
              if (res.data && res.data.code === 400) {
                this.$Message.error(res.data.message)
              } else {
                this.$Message.success('新增成功')
                this.loadData()
                this.isShowEdit = false
              }
            }).catch(error => {
              this.$Message.error(error)
            })
          }
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    // getAppList (id = '') {
    //   let params = {
    //     page_size: 200,
    //     page: 1
    //   }
    //   https.request({
    //     method: 'get',
    //     url: '/v1/tvp/list',
    //     params: params
    //   }).then(res => {
    //     this.appList = res.data.list
    //   }).catch(error => {
    //     this.$Message.error(error)
    //   })
    // },
    changeAppId (val) {
      this.loadData(val)
    },
    clearAppId () {
      this.loadData()
    },
    searchBtn () {
      this.loadData(this.searchName, this.searchCode)
    },
    searchClear () {
      this.searchName = ''
      this.searchCode = ''
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .input_left_two{
    left:340px;
    // left:580px;
  }
  .option-wrap-channel{
    margin-top:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/channelManage.vue